import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { EventsActions } from "./index";
import { IEventsState, initialEvent, initialEventsState } from "./events.types";
import {
  CLEAR_EVENT,
  CLEAR_EVENT_STATE,
  FETCH_EVENTS_LIST_FAILED,
  FETCH_EVENTS_LIST_PROGRESS,
  FETCH_EVENTS_LIST_SUCCESS,
  FETCH_EVENT_FAILED,
  FETCH_EVENT_PROGRESS,
  FETCH_EVENT_SUCCESS,
  UPSERT_EVENT_FAILED,
  UPSERT_EVENT_PROGRESS,
  UPSERT_EVENT_SUCCESS,
} from "./eventsActions";

export const eventsReducer = (
  state: IStoreState["events"] = initialEventsState,
  action: EventsActions
) => {
  switch (action.type) {
    case FETCH_EVENTS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_EVENTS_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = list;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_EVENTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_EVENT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.event.loading = LoadState.InProgress;
        draftState.event.data = initialEvent;
      });
      return newState;
    }
    case FETCH_EVENT_SUCCESS: {
      const { event } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.event.loading = LoadState.Loaded;
        draftState.event.data = event;
      });
      return newState;
    }
    case FETCH_EVENT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.event.loading = LoadState.Failed;
        draftState.event.error = errorMessage;
      });
      return newState;
    }
    case UPSERT_EVENT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.event.loading = LoadState.InProgress;
      });
      return newState;
    }
    case UPSERT_EVENT_SUCCESS: {
      const { event } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.event.loading = LoadState.Loaded;
        draftState.event.data = event;
      });
      return newState;
    }
    case UPSERT_EVENT_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.event.loading = LoadState.Failed;
        draftState.event.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_EVENT: {
      const newState = produce(state, (draftState) => {
        draftState.event.loading = LoadState.NotLoaded;
        draftState.event.data = initialEvent;
      });
      return newState;
    }
    case CLEAR_EVENT_STATE: {
      return initialEventsState;
    }
    default: {
      return state;
    }
  }
}; 